export default __webpack_public_path__ + "static/media/electrostatic-cleaning.f75dffbd.jpg";